import React from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/ui/loadingSpinner';
import View from 'components/ui/view';
import Button from 'components/ui/button';
import ProductItem from 'components/productItem/base';

export default function SubstitutionOptions({
  list,
  loading,
  baseUrl,
  chooseSubstitution
}) {
  return (
    <View
      padding="sm"
      className="substitutions-detail__product-list-container clearfix"
    >
      {loading ? (
        <div
          style={{
            minHeight: '300px',
            position: 'relative',
            marginTop: '75px'
          }}
        >
          <LoadingSpinner black />
        </div>
      ) : !list.length ? (
        <View padding="lg" className="text-center" tag="p">
          Sorry, we couldn{"'"}t find any substitutions for this product right
          now. Please remove it from your order or contact support.
        </View>
      ) : (
        list.map((product, idx) => (
          <div
            key={`${product.sku_id}-${idx}`}
            className="substitutions-detail__list-item"
          >
            <Link
              to={{
                pathname: `${baseUrl}/${product.sku_id}`,
                state: { from: 'options' }
              }}
            >
              <ProductItem
                product={product}
                renderOnHover={() =>
                  product.price ? (
                    <Button
                      primary
                      onClick={e => {
                        e.preventDefault();
                        chooseSubstitution(product);
                      }}
                    >
                      Substitute
                    </Button>
                  ) : null}
              />
            </Link>
          </div>
        ))
      )}
    </View>
  );
}



// WEBPACK FOOTER //
// ./shared/components/substitutions/options.js